/**
 * Staggered fade-in
 *
 * Children of a [data-stagger] container fade up as they scroll into view,
 * delayed by their column position so a row reveals left-to-right and each row
 * starts as it arrives. Column count is read from the grid at run time, so it
 * follows the block's responsive layout (and collapses to no delay when the
 * grid is a single column).
 *
 * Items are observed individually rather than as a group, so a tall grid never
 * animates rows that are still off screen.
 *
 * Reduced motion, or no JS, leaves everything visible.
 */
( function () {
	'use strict';

	var STEP = 120; // ms between items in a row

	function columnCount( grid ) {
		var columns = window.getComputedStyle( grid ).gridTemplateColumns;

		if ( ! columns || 'none' === columns ) {
			return 1;
		}

		return columns.split( ' ' ).filter( function ( value ) {
			return value.trim().length;
		} ).length || 1;
	}

	function init() {
		var grids = document.querySelectorAll( '[data-stagger]' );

		if ( ! grids.length ) {
			return;
		}

		var reduced = window.matchMedia && window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches;

		if ( reduced || ! ( 'IntersectionObserver' in window ) ) {
			for ( var g = 0; g < grids.length; g++ ) {
				grids[ g ].classList.add( 'stagger-ready', 'stagger-done' );
			}
			return;
		}

		var observer = new IntersectionObserver( function ( entries ) {
			for ( var i = 0; i < entries.length; i++ ) {
				if ( entries[ i ].isIntersecting ) {
					entries[ i ].target.classList.add( 'is-visible' );
					observer.unobserve( entries[ i ].target );
				}
			}
		}, { rootMargin: '0px 0px -10% 0px', threshold: 0.15 } );

		var pending = [];

		for ( var j = 0; j < grids.length; j++ ) {
			var grid = grids[ j ];
			var items = grid.children;
			var columns = columnCount( grid );

			// Only hide the items once we know the script is running, so a JS
			// failure can never leave the grid blank.
			grid.classList.add( 'stagger-ready' );

			for ( var k = 0; k < items.length; k++ ) {
				items[ k ].style.setProperty( '--stagger-step', ( k % columns ) );
				pending.push( items[ k ] );
			}
		}

		// Start observing only after the hidden state has been painted. Adding
		// .stagger-ready and .is-visible in the same frame gives the browser no
		// start value to interpolate from, so the items snap in instead of
		// fading — which is exactly what happens to anything already on screen
		// at load, since the observer fires immediately for those.
		requestAnimationFrame( function () {
			requestAnimationFrame( function () {
				for ( var i = 0; i < pending.length; i++ ) {
					observer.observe( pending[ i ] );
				}
			} );
		} );
	}

	if ( 'loading' === document.readyState ) {
		document.addEventListener( 'DOMContentLoaded', init );
	} else {
		init();
	}

	window.addEventListener( 'load', function () {
		// Column count can change once webfonts/images settle the layout.
		var grids = document.querySelectorAll( '[data-stagger].stagger-ready' );

		for ( var i = 0; i < grids.length; i++ ) {
			var items = grids[ i ].children;
			var columns = columnCount( grids[ i ] );

			for ( var k = 0; k < items.length; k++ ) {
				if ( ! items[ k ].classList.contains( 'is-visible' ) ) {
					items[ k ].style.setProperty( '--stagger-step', ( k % columns ) );
				}
			}
		}
	} );
}() );
